import { render, staticRenderFns } from "./pardakht_shakhsi.vue?vue&type=template&id=205d678c&"
import script from "./pardakht_shakhsi.vue?vue&type=script&lang=js&"
export * from "./pardakht_shakhsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports